import input from '../../components/_primitives/input/variants.esm.js';
import textarea from '../../components/_primitives/text-area/variants.esm.js';
import checkbox from '../../components/checkbox/variants.esm.js';
import radio from '../../components/radio/variants.esm.js';
import selectVariants from '../../components/react-select/variants.esm.js';

var forms = {
  checkbox: checkbox,
  input: input,
  select: selectVariants,
  textarea: textarea,
  radio: radio
};

export { forms };
//# sourceMappingURL=index.esm.js.map
